import { getClient } from '@/api/api-client';
import { type ILocationProfile, type ILocationProfilesResponse, locationProfileToDto } from '@condo/domain';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';

export const fetchLocationProfiles = ({ estateId }: { estateId?: number }) => {
    return getClient('basecamp')
        .get<AxiosRequestConfig<{ estateId?: number }>, AxiosResponse<ILocationProfilesResponse>>('/location-profiles', {
            params: {
                estateId,
            },
        })
        .then(response => {
            const { locationProfiles } = response.data;
            return locationProfiles;
        });
};

export const fetchLocationProfile = (locationProfileId: number) => {
    return getClient('basecamp')
        .get<ILocationProfilesResponse>('/location-profiles/:locationProfileId', { params: { locationProfileId } })
        .then(({ data: { locationProfiles } }) => locationProfiles);
};

export const upsertLocationProfile = (locationProfile: ILocationProfile) => {
    if (locationProfile.locationProfileId) {
        return getClient('basecamp')
            .patch<Partial<ILocationProfile>, AxiosResponse<ILocationProfilesResponse>>(
                `/location-profiles/${locationProfile.locationProfileId}`,
                locationProfileToDto(locationProfile),
            )
            .then(({ data: { locationProfiles } }) => locationProfiles);
    }

    return getClient('basecamp')
        .post<Partial<ILocationProfile>, AxiosResponse<ILocationProfilesResponse>>('/location-profiles', locationProfile)
        .then(({ data: { locationProfiles } }) => locationProfiles);
};

export const deleteLocationProfile = (locationProfileId: number) => {
    return getClient('basecamp')
        .delete<{ locationProfileId: number }, AxiosResponse<ILocationProfilesResponse>>(`/location-profiles/${locationProfileId}`)
        .then(({ data: { locationProfiles } }) => locationProfiles);
};
